import React, { PureComponent } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory from "react-bootstrap-table2-filter";

import {
  MetricTable,
  sortNumeric,
  selectFormat,
  sortDate,
  Error,
} from "components/Utils/Utils.js";

const metricFormatter = (cell, row, rowIndex, enumObject) => {
  const props = { ...cell, ...enumObject };
  return <MetricTable {...props} />;
};

const dateFormatter = (cell) => {
  if (cell && cell.date) {
    return cell.title;
  } else {
    return cell;
  }
};

class AdsDataByNetwork extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  renderTable(data, columns, footer, pagination) {
    const { title } = this.props;

    const selected_columns = [];

    // add unique ids
    data.forEach((d, i) => (d.id = i));

    const defaultSortType = "date_title";

    const total_index = data.findIndex(({ source }) => source === "Total");
    let table_data = data.slice(0);
    const footer_data = footer
      ? table_data.splice(total_index, 1)[0]
      : table_data;

    const table_columns = [
      {
        dataField: "date_title",
        text: "Title",
        style: { width: "120px", minWidth: "120px" },
        headerAlign: "left",
        formatter: dateFormatter,
        csvFormatter: dateFormatter,
        sort: true,
        sortFunc: sortDate,
        footer: footer_data["date_title"],
        footerFormatter: (col) => dateFormatter(col.footer),
      },
      {
        dataField: "impressions",
        text: "IMPs",
        style: { width: "60px", minWidth: "60px" },
        formatter: metricFormatter,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
        footer: footer_data["impressions"],
        footerFormatter: (col) => metricFormatter(col.footer),
      },
      {
        dataField: "clicks",
        text: "Clicks",
        style: { width: "80px", minWidth: "80px" },
        formatter: metricFormatter,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        footer: footer_data["clicks"],
        footerFormatter: (col) => metricFormatter(col.footer),
      },
      {
        dataField: "ctr",
        text: "CTR",
        style: { width: "70px", minWidth: "70px" },
        formatter: metricFormatter,
        formatExtraData: { type: "percentage", format: "0.00%" },
        csvFormatter: (cell) =>
          selectFormat("percentage", cell && cell.value, "0.00%"),
        sort: true,
        sortFunc: sortNumeric,
        footer: footer_data["ctr"],
        footerFormatter: (col) =>
          metricFormatter(col.footer, null, null, col.formatExtraData),
      },
      {
        dataField: "cpc",
        text: "CPC",
        style: { width: "70px", minWidth: "70px" },
        formatter: metricFormatter,
        formatExtraData: { type: "currency-GB" },
        csvFormatter: (cell) => selectFormat("currency-GB", cell && cell.value),
        sort: true,
        sortFunc: sortNumeric,
        footer: footer_data["cpc"],
        footerFormatter: (col) =>
          metricFormatter(col.footer, null, null, col.formatExtraData),
      },
      {
        dataField: "cpa",
        text: "CPA",
        style: { width: "70px", minWidth: "70px" },
        formatter: metricFormatter,
        formatExtraData: { type: "currency-GB" },
        csvFormatter: (cell) => selectFormat("currency-GB", cell && cell.value),
        sort: true,
        sortFunc: sortNumeric,
        footer: footer_data["cpa"],
        footerFormatter: (col) =>
          metricFormatter(col.footer, null, null, col.formatExtraData),
      },
      {
        dataField: "agency_cost",
        text: "Agency Cost",
        style: { width: "120px", minWidth: "120px" },
        formatter: metricFormatter,
        formatExtraData: { type: "currency-GB" },
        csvFormatter: (cell) => selectFormat("currency-GB", cell && cell.value),
        sort: true,
        sortFunc: sortNumeric,
        footer: footer_data["agency_cost"],
        footerFormatter: (col) =>
          metricFormatter(col.footer, null, null, col.formatExtraData),
      },
      {
        dataField: "client_cost",
        text: "Client Cost",
        style: { width: "100px", minWidth: "100px" },
        formatter: metricFormatter,
        formatExtraData: { type: "currency-GB" },
        csvFormatter: (cell) => selectFormat("currency-GB", cell && cell.value),
        sort: true,
        sortFunc: sortNumeric,
        footer: footer_data["client_cost"],
        footerFormatter: (col) =>
          metricFormatter(col.footer, null, null, col.formatExtraData),
      },
    ];

    let paginate = null;

    columns.map((column) =>
      selected_columns.push(table_columns.find((o) => o.dataField === column))
    );

    const defaultSorted = [
      {
        dataField: defaultSortType,
        order: "desc",
      },
    ];

    if (pagination === true) {
      paginate = paginationFactory({
        sizePerPage: 10,
        hideSizePerPage: true,
      });
    }

    const filename = title.split(" ").join("_") || "spreadsheet";

    return (
      <ToolkitProvider
        keyField="id"
        data={table_data}
        columns={selected_columns}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
        striped={false}
        hover={false}
        bordered={false}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            defaultSorted={defaultSorted}
            pagination={paginate}
            filter={filterFactory()}
            footerClasses={footer ? "tfoot__tr" : "tfoot__tr d-none"}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data, columns, footer, pagination } = this.props;
    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return this.renderTable(data.data, columns, footer, pagination);
  }
}

export default AdsDataByNetwork;
